import { queryOptions } from '@tanstack/react-query';

import type { CalendarConnectionDto } from '@/api/core-api/types.gen';

import { calendarConnectionControllerGet } from '@/api/core-api/sdk.gen';
import { queryKeys } from '@/hooks/api/query-keys';
import { getClient } from '@/utils/get-api-client';

export function calendarConnectionQueryOptions(userId: string) {
  return queryOptions({
    queryKey: queryKeys.calendarConnection.byUserId(userId),
    queryFn: async (): Promise<CalendarConnectionDto> => {
      const { data } = await calendarConnectionControllerGet({
        client: getClient(userId),
        throwOnError: true,
      });
      return data;
    },
  });
}
